import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./views/LandingPage";
import "./App.css";
import { FiSun, FiMoon } from "react-icons/fi";

const THEME_KEY = "theme";
const LIGHT = "light";
const DARK = "dark";

function getInitialTheme() {
  // Try localStorage, then system preference, then default to light
  if (typeof window !== "undefined") {
    const stored = localStorage.getItem(THEME_KEY);
    if (stored === LIGHT || stored === DARK) return stored;
    if (window.matchMedia("(prefers-color-scheme: dark)").matches) return DARK;
  }
  return LIGHT;
}

function App() {
  const [theme, setTheme] = useState(getInitialTheme);

  // Set theme on <html> and persist to localStorage
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem(THEME_KEY, theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === LIGHT ? DARK : LIGHT));
  };

  return (
    <>
      {/* Floating theme toggle button */}
      <button
        className="floating-theme-toggle"
        onClick={toggleTheme}
        aria-label={`Switch to ${theme === LIGHT ? "dark" : "light"} mode`}
        title={`Switch to ${theme === LIGHT ? "dark" : "light"} mode`}
      >
        {theme === LIGHT ? <FiMoon /> : <FiSun />}
      </button>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          {/* Add more routes as needed */}
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
